module.exports = __webpack_public_path__ + "img/130.296edbaa.jpg";